{
  "name": "@ns/public-ledger-auto-payments-setup",
  "version": "1.0.0",
  "description": "Set up automatic payments for the company's public ledger actions (#25). Claimable by the company's public ledger signatories. The signatory who claims it saves a card for off-session payments (public-ledger/autopay/setup-intent, then confirm-setup; they become the card's owner) and chooses the company threshold (credits) and target (£), the operating threshold and target (credits), the monthly card and top-up limits (£) and the price alert percentage, which public-ledger/autopay/propose checks and records. Completed with proposed once propose has answered (the workflow then schedules the approval for every signatory to sign), or cancel.",
  "inputs": {},
  "outcomes": {
    "proposed": {},
    "cancel": {}
  }
}
